import React, { Component } from "react";
import { connect } from "react-redux";
import { AddToCalendar } from "./components";
import { SlideInUpAnimation } from "../BookingPortal/components/Shared/Animation";
import LocationMap from "../BookingPortal/components/Steps/DrawerContent/LocationMap";
import { appointmentSummarySelector } from "../ContactForm/selectors";
import { printConfirmation } from "./components/Helper";
import { makeNewBooking } from "../BookingPortal/actions";
import { portalService } from "../BookingPortal/services";

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = { position: props.position };
  }

  componentDidMount = async () => {
    const { position } = this.props;

    if (!position) {
      const { data } = await portalService.getLocationPosition(position);
      if (data != null) {
        const { lat, lng } = data;
        this.setState({ position: { lat, lng } });
      }
    }
  };

  renderAppointmentDetails = () => {
    const {
      hideSpecialty,
      specialtyType,
      appointmentType,
      practitioner,
      location,
      appointmentDateTime
    } = this.props;
    return (
      <ul className="booking-details">
        {hideSpecialty ? null : (
          <li>
            <div className="detail-label">Service</div>
            <div className="detail-content">{specialtyType}</div>
          </li>
        )}
        <li>
          <div className="detail-label">Appointment Type</div>
          <div className="detail-content">{appointmentType}</div>
        </li>
        <li>
          <div className="detail-label">with</div>
          <div className="detail-content">{practitioner}</div>
        </li>
        <li>
          <div className="detail-label">Location</div>
          <div className="detail-content">{location}</div>
        </li>
        <li>
          <div className="detail-label">Appointment Time</div>
          <div className="detail-content">{appointmentDateTime}</div>
        </li>
      </ul>
    );
  };

  renderHeading = () => {
    return this.props.requireWaitingList ? (
      <h3>{this.props.waitingListConfirmationText}</h3>
    ) : (
      <h3>Your appointment has been booked</h3>
    );
  };

  renderAppointmentReminder = () => {
    if (
      this.props.hideSpecialty ||
      this.props.requireWaitingList ||
      this.props.isMedibank
    ) {
      return null;
    }
    return <p>Please arrive 15 minutes before the appointment time</p>;
  };

  renderAddToCalendar = () => {
    if (this.props.requireWaitingList) return null;
    return (
      <AddToCalendar
        appointment={{
          title: "appointment confirmation",
          description: "appointment confirmation",
          location: this.props.location,
          startDateTime: this.props.appointmentStartTime,
          endDateTime: this.props.appointmentEndTime
        }}
      />
    );
  };
  render() {
    return (
      <SlideInUpAnimation>
        <div className="booking-confirmation-container">
          <div id="printable">
            <div className="box-header">{this.renderHeading()}</div>

            <div className="box-content">
              <div className="row">
                <div className="col-sm-7">
                  <div className="map-container">
                    <LocationMap
                      zoom={15}
                      position={this.state.position}
                      containerElement={
                        <div className="google-map-container" />
                      }
                    />
                  </div>
                </div>
                <div className="col-sm-5">
                  {this.renderAppointmentDetails()}
                  {this.renderAddToCalendar()}
                </div>
              </div>
            </div>
          </div>

          <div className="box-footer">
            <button
              className="btn btn-transparent-black float-left"
              onClick={this.props.makeNewBooking}
            >
              Make a New Booking
            </button>
            <button
              className="btn btn-transparent-black float-right"
              onClick={printConfirmation}
            >
              Print
            </button>
          </div>
        </div>
      </SlideInUpAnimation>
    );
  }
}

export default connect(
  appointmentSummarySelector,
  { makeNewBooking }
)(Confirmation);



// WEBPACK FOOTER //
// ./src/modules/Confirm/index.js